import React, { FC, ReactElement } from 'react'
import Dialog from '../../../../React/Common/Components/Modal/Dialog'
import { ModalExitPromptContextProvider } from '../../../../React/Common/Components/Modal/ModalExitPromptContext'

type Props = {
    className?: string
    isOpen: boolean
    onClose: () => void
    children: ReactElement | ReactElement[]
}

export const Modal: FC<Props> = ({ className, isOpen, onClose, children }: Props): ReactElement => (
    <ModalExitPromptContextProvider>
        <Dialog
            isOpen={isOpen}
            onClose={onClose}
            isClosableWithXButton
            closeOnBackdropClick
            classNames={`router-modal ${className}`}
        >
            {children}
        </Dialog>
    </ModalExitPromptContextProvider>
)
